import { render, staticRenderFns } from "./CommercialMultitenantOfficePremises.vue?vue&type=template&id=c6c5c670&scoped=true&"
import script from "./CommercialMultitenantOfficePremises.vue?vue&type=script&lang=ts&"
export * from "./CommercialMultitenantOfficePremises.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialMultitenantOfficePremises.vue?vue&type=style&index=0&id=c6c5c670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5c670",
  null
  
)

export default component.exports